export const css = {
	root: '_259LJNRK',
	title: '_jCOOvS0',
	body: '_31CjR-MK',
	warning: 'kwv5EJoH',
	' _key': 'ascm-theme/ascm/learning-activity/activity'
};

export default css;
